// extracted by mini-css-extract-plugin
module.exports = {"tree-table":"TermInfo_tree-table__rAXYg"};